import { ApplicationEmbedded } from "../application/types";
import { Entity } from "../core/Entity";
import { LayoutSourceEmbedded } from "../layout_source/types";
import { WizardInstanceEmbedded } from "../wizard_instance/types";

export type LayoutInsertTextContent = {
  content: string;
  fontSize: number;
  alignment: "left" | "center" | "right";
};

export type LayoutInsertImageContent = {
  content: string;
  source: "embedded" | "stored";
};

export enum LayoutInsertType {
  TEXT = "text",
  IMAGE = "image",
  TEXT_AND_IMAGE = "text-and-image",
}

export type LayoutInsert = {
  ref: string;
  type: LayoutInsertType;
  llx: number;
  lly: number;
  width: number;
  height: number;
  page: number;
  textContent?: LayoutInsertTextContent;
  imageContent?: LayoutInsertImageContent;
};

export type LayoutGetResponse = Entity<{
  application: ApplicationEmbedded;
  source: LayoutSourceEmbedded;
  wizardInstance: WizardInstanceEmbedded;
  name: string;
  inserts: LayoutInsert[];
}>;

export type EditingLayout = Pick<
  LayoutGetResponse,
  "id" | "inserts" | "name" | "createdAt" | "updatedAt"
>;

export type CreatingLayout = Pick<LayoutGetResponse, "name" | "inserts">;

export type LayoutPostPayload = CreatingLayout & {
  layoutSourceId: string;
  wizardInstanceId: string;
};

export const layoutInsertTypes = [
  {
    value: "text",
    text: "Texto",
  },
  {
    value: "image",
    text: "Imágen",
  },
  {
    value: "text-and-image",
    text: "Texto e imágen",
  },
];

export const layoutInsertTextContentAlignments = [
  {
    value: "left",
    text: "Izquierda",
  },
  {
    value: "center",
    text: "Centro",
  },
  {
    value: "right",
    text: "Derecha",
  },
];

export const RESOURCE_PATH = "/layouts";

export const LAYOUTINSERT_DEFAULT_WIDTH = 250;
export const LAYOUTINSERT_DEFAULT_HEIGHT = 100;
